// Information and Ideas reference sheet — quick-lookup checklists for this
// domain, as opposed to the instructional walkthroughs in the Reading and
// Writing domain guide. Keep entries short: a rule or list, not a lesson.
// Paragraphs are plain strings or structured blocks
// { type: 'steps' | 'list', ... }.

export const documentTitle = 'Information and Ideas Reference';
export const documentSlug = 'information-and-ideas-reference';

export const parts = [
  {
    id: 'information-ideas-reference-full',
    title: null,
    sections: [
      {
        id: 'iir-central-idea-vs-detail',
        heading: 'Central Idea vs. Detail',
        paragraphs: [
          {
            type: 'list',
            items: [
              'A central idea covers what the whole passage is about.',
              'A detail is one piece of support for that idea.',
            ],
          },
          "Eliminate answer choices that are true but too narrow to be the passage's actual main point.",
        ],
      },
      {
        id: 'iir-textual-evidence-checklist',
        heading: 'Textual Evidence Checklist',
        paragraphs: [
          {
            type: 'steps',
            steps: [
              'Read the claim first.',
              "Find the quotation that most directly and specifically supports that exact claim — not one that's simply true, and not one that restates the claim instead of backing it up.",
            ],
          },
        ],
      },
      {
        id: 'iir-quantitative-evidence-checklist',
        heading: 'Quantitative Evidence Checklist',
        paragraphs: [
          {
            type: 'steps',
            steps: [
              'Check axis labels and units before comparing numbers.',
              'Match the exact data point or comparison the claim requires — "increased every year" and "more than doubled" are both true of the same data but support different claims.',
            ],
          },
        ],
      },
      {
        id: 'iir-inference-test',
        heading: 'The Inference Test',
        paragraphs: [
          'Ask: must this be true given the passage, or could the passage be true while this answer choice is false? If it could still be false, it\'s too big a leap to be a correct inference.',
        ],
      },
    ],
  },
];
